import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/app/(auth)/zabudnute-heslo/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www-local/frontend/lides/lides-sk-01/components/forms/forgottenPassword/ForgottenPassword.jsx");
